import Vuex from 'vuex';
import Vue from "vue";
import {getCommentList} from "VueApps/comments/actions/getCommentList";
import {
    CANCEL_COMMENT_EDITING_ACTION,
    CHANGE_ORDER_ACTION,
    COMPLAIN_ON_COMMENT_ACTION,
    CREATE_COMMENT_ACTION,
    DELETE_COMMENT_ACTION,
    HIDE_MODAL_ACTION,
    HIGHLIGHT_COMMENT_ACTION,
    INIT_ACTION,
    LIKE_COMMENT_ACTION,
    OPEN_INPUT_ACTION,
    START_COMMENT_EDITING_ACTION,
    UPDATE_COMMENT_ACTION
} from "VueApps/comments/actions/actions";
import {
    CANCEL_COMMENT_EDITING_MUTATION,
    CHANGE_COMMENT_LIKE_MUTATION,
    CHANGE_COMMENT_STATUS_MUTATION,
    CHANGE_COMMENT_TEXT_AFTER_UPDATE_MUTATION,
    CHANGE_HIGHLIGHT_COMMENT_ID_MUTATION,
    CHANGE_SELECTED_ANSWER_TO_ID_MUTATION,
    HIDE_MODAL_MUTATION,
    PREPARE_COMMENT_FOR_EDITING_MUTATION,
    REMOVE_HIGHLIGHT_OF_COMMENT_ID_MUTATION,
    SHOW_MODAL_MUTATION,
    UPDATE_COMPONENT_STATE_AFTER_COMMENT_CREATING_MUTATION,
    UPDATE_COMPONENT_STATE_MUTATION,
} from "VueApps/comments/store/mutations";
import {createComment} from "VueApps/comments/actions/createComment";
import {complainOnComment} from "VueApps/comments/actions/complainOnComment";
import {getEditingComment} from "VueApps/comments/actions/getEditingComment";
import {updateComment} from "VueApps/comments/actions/updateComment";
import {likeComment} from "VueApps/comments/actions/likeComment";
import {deleteComment} from "VueApps/comments/actions/deleteComment";
import {COMMENT_TIME_UPDATE_ENDS, INCORRECT_COMMENT_USER} from '../../../core/error-codes';
import {getMessageByErrorCode} from "Core/error-messages";
import {dispatchEvent, CHANGE_MATERIAL_URL_EVENT_NAME} from '../../../common/events';

Vue.use(Vuex);

const actions = {};
const TIME_TO_HIDE = 10000;

const hideModal = (context) => {
    setTimeout(function () {
        context.commit(HIDE_MODAL_MUTATION);
    }, TIME_TO_HIDE);
};

actions[INIT_ACTION] = (context, payload) => {
    return getCommentList(payload.entityId, payload.type, payload.order)
        .then(response => {
            return context.commit(UPDATE_COMPONENT_STATE_MUTATION, response);
        });
};

actions[CHANGE_ORDER_ACTION] = (context, payload) => {
    if (payload.order === context.state.componentState.order) {
        return;
    }

    getCommentList(
        context.state.componentState.entityId,
        context.state.componentState.type,
        payload.order
    )
        .then(response => {
            context.commit(UPDATE_COMPONENT_STATE_MUTATION, response);
        });
};

actions[OPEN_INPUT_ACTION] = (context, payload) => {
    context.commit(CHANGE_SELECTED_ANSWER_TO_ID_MUTATION, payload);
};

actions[CREATE_COMMENT_ACTION] = (context, payload) => {
    createComment({
        entityId: context.state.componentState.entityId,
        type: context.state.componentState.type,
        text: payload.text,
        answerToId: payload.answerToId,
        order: context.state.componentState.order,
    })
        .then(response => {
            context.commit(UPDATE_COMPONENT_STATE_AFTER_COMMENT_CREATING_MUTATION, response);
        })
        .catch(error => {
            console.log(error);
        });
};

actions[START_COMMENT_EDITING_ACTION] = (context, payload) => {
    getEditingComment(payload.commentId)
        .then(response => {
            switch (response.httpCode) {
                case 400:
                    switch (response.code) {
                        case COMMENT_TIME_UPDATE_ENDS:
                            context.commit(SHOW_MODAL_MUTATION, getMessageByErrorCode(COMMENT_TIME_UPDATE_ENDS));

                            hideModal(context);

                            break;
                        case INCORRECT_COMMENT_USER:
                            context.commit(SHOW_MODAL_MUTATION, getMessageByErrorCode(INCORRECT_COMMENT_USER));

                            hideModal(context);

                            break;
                    }

                    return;
                case 200:
                    context.commit(PREPARE_COMMENT_FOR_EDITING_MUTATION, {
                        commentId: payload.commentId,
                        editingText: response.origin_text
                    });

                    return;
            }

            context.commit(SHOW_MODAL_MUTATION, getMessageByErrorCode(''));

            hideModal(context);
        })
        .catch(error => {
            console.log(error);
        });
};

actions[CANCEL_COMMENT_EDITING_ACTION] = (context) => {
    context.commit(CANCEL_COMMENT_EDITING_MUTATION);
};

actions[UPDATE_COMMENT_ACTION] = (context, payload) => {
    context.commit(CANCEL_COMMENT_EDITING_MUTATION);

    updateComment({
        commentId: payload.commentId,
        text: payload.text
    })
        .then(response => {
            context.commit(CHANGE_COMMENT_TEXT_AFTER_UPDATE_MUTATION, response);
        })
        .catch((error) => {
            console.log(error)
        });
};

actions[HIDE_MODAL_ACTION] = (context) => {
    context.commit(HIDE_MODAL_MUTATION);
};

actions[LIKE_COMMENT_ACTION] = (context, payload) => {
    likeComment({
        commentId: payload.commentId,
        status: payload.status
    }).then(response => {
        context.commit(CHANGE_COMMENT_LIKE_MUTATION, response)
    })
};

actions[HIGHLIGHT_COMMENT_ACTION] = (context, payload) => {
    context.commit(CHANGE_HIGHLIGHT_COMMENT_ID_MUTATION, payload);

    setTimeout(function () {
        context.commit(REMOVE_HIGHLIGHT_OF_COMMENT_ID_MUTATION);
    }, 2500)
};

actions[DELETE_COMMENT_ACTION] = (context, payload) => {
    deleteComment({
        commentId: payload.commentId
    })
        .then(response => {
            context.commit(CHANGE_COMMENT_STATUS_MUTATION, response)
        })
        .catch(error => {
            console.log(error);
        });
};

actions[COMPLAIN_ON_COMMENT_ACTION] = (context, payload) => {
    complainOnComment(payload.commentId)
        .then(response => {
            context.commit(CHANGE_COMMENT_STATUS_MUTATION, response)
        })
        .catch(error => {
            console.log(error);
        });
};

const mutations = {};

mutations[UPDATE_COMPONENT_STATE_MUTATION] = (state, payload) => {
    state.componentState = payload;
    state.isReady = true;
    state.selectedAnswerToId = null;

    dispatchEvent(CHANGE_MATERIAL_URL_EVENT_NAME, {
        detail: {
            entityId: state.componentState.entityId
        }
    });
};

mutations[UPDATE_COMPONENT_STATE_AFTER_COMMENT_CREATING_MUTATION] = (state, payload) => {
    state.selectedAnswerToId = null;

    if (state.componentState.comments[payload.id] === undefined) {
        Vue.set(state.componentState.comments, payload.id, payload);
    }

    state.componentState.totalCount++;

    dispatchEvent(CHANGE_MATERIAL_URL_EVENT_NAME, {
        detail: {
            entityId: state.componentState.entityId
        }
    });

    if (typeof state.componentState.comments[payload.answerToId] === 'undefined') {
        state.componentState.rootIds.unshift(payload.id);
        state.componentState.rootAnswerIds[payload.id] = [];
        return;
    }

    let rootAnswerIds = Object.assign({}, state.componentState.rootAnswerIds);

    rootAnswerIds[payload.parentId].unshift(payload.id);

    state.componentState.rootAnswerIds = rootAnswerIds;
};

mutations[CHANGE_SELECTED_ANSWER_TO_ID_MUTATION] = (state, payload) => {
    state.editingText = null;
    state.isEditing = false;
    state.selectedAnswerToId = payload.answerToId;
};

mutations[PREPARE_COMMENT_FOR_EDITING_MUTATION] = (state, payload) => {
    state.selectedAnswerToId = payload.commentId;
    state.editingText = payload.editingText;
    state.isEditing = true;
};

mutations[CANCEL_COMMENT_EDITING_MUTATION] = (state) => {
    state.selectedAnswerToId = null;
    state.editingText = null;
    state.isEditing = false;
};

mutations[CHANGE_COMMENT_TEXT_AFTER_UPDATE_MUTATION] = (state, updatedComment) => {
    state.selectedAnswerToId = null;
    state.editingText = null;
    state.isEditing = false;
    state.componentState.comments[updatedComment.id] = updatedComment;
};

mutations[CHANGE_COMMENT_LIKE_MUTATION] = (state, likeComment) => {
    state.componentState.comments[likeComment.id].likes = likeComment.likes;
};

mutations[CHANGE_COMMENT_STATUS_MUTATION] = (state, updatedComment) => {
    state.componentState.comments[updatedComment.id].status = updatedComment.status;
};

mutations[SHOW_MODAL_MUTATION] = (state, modalMessage) => {
    state.isModalOpen = true;
    state.modalMessage = modalMessage;
};

mutations[HIDE_MODAL_MUTATION] = (state) => {
    state.isModalOpen = false;
    state.modalMessage = null;
};

mutations[CHANGE_HIGHLIGHT_COMMENT_ID_MUTATION] = (state, payload) => {
    state.highlightCommentId = payload.commentId;
};

mutations[REMOVE_HIGHLIGHT_OF_COMMENT_ID_MUTATION] = (state, payload) => {
    state.highlightCommentId = null;
};

export default () => {
    return new Vuex.Store({
        state: {
            componentState: {
                entityId: null,
                type: null,
                rootCount: 0,
                totalCount: 0,
                offset: 0,
                comments: {},
                rootIds: [],
                rootAnswerIds: {},
                order: null,
            },
            isReady: false,
            selectedAnswerToId: null,
            editingText: null,
            isEditing: false,
            isModalOpen: false,
            modalMessage: null,
            highlightCommentId: null,
        },
        mutations: mutations,
        actions: actions
    })
};
